import { render } from "./item-table.vue?vue&type=template&id=3a5a341d&scoped=true"
import script from "./item-table.vue?vue&type=script&lang=js"
export * from "./item-table.vue?vue&type=script&lang=js"

import "./item-table.vue?vue&type=style&index=0&id=3a5a341d&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5a341d"]])

export default __exports__